import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { CollectionLeaderboard } from 'components/collections/CollectionLeaderboard';

import type {
  CollectionLeaderboardPageQuery,
  CollectionLeaderboardPageQueryVariables,
} from './__generated__/index.graphql';

const COLLECTION_LEADERBOARD_QUERY = gql`
  query CollectionLeaderboardPageQuery(
    $collection: String!
    $slug: String!
    $sport: Sport!
  ) {
    cardCollection(slug: $collection) {
      slug
      slotsCount
      userCardCollection(forUserSlug: $slug) {
        id
        ...CollectionLeaderboard_userCardCollection
      }
    }
  }
  ${CollectionLeaderboard.fragments.userCardCollection}
` as TypedDocumentNode<
  CollectionLeaderboardPageQuery,
  CollectionLeaderboardPageQueryVariables
>;

type Props = {
  collection: string;
  slug: string;
};

export const LeaderboardPage = ({ collection, slug }: Props) => {
  const { sport } = useSportContext();
  const { data } = useQuery(COLLECTION_LEADERBOARD_QUERY, {
    variables: {
      collection,
      slug,
      sport,
    },
  });
  const { cardCollection } = data || {};

  return (
    <CollectionLeaderboard
      slug={collection}
      slotsCount={cardCollection?.slotsCount || 0}
      myUserCardCollection={cardCollection?.userCardCollection}
    />
  );
};
